import { IHoldingsRequest, IAssetDrilldownRequest, IAssetPerformance, IHoldingsExposuresDataResult, IHoldingsValuationsDataResult } from 'src/app/models/holdings';
import { Action } from '@ngrx/store';

export const GET_PORTFOLIOS = 'GET_PORTFOLIOS';
export const SET_PORTFOLIOS = 'SET_PORTFOLIOS';
export const GET_HOLDINGS_VALUATION_DATA = 'GET_HOLDINGS_VALUATION_DATA';
export const SET_HOLDINGS_VALUATION_DATA = 'SET_HOLDINGS_VALUATION_DATA';
export const GET_HOLDINGS_ALLOCATIONS_DATA = 'GET_HOLDINGS_ALLOCATIONS_DATA';
export const GET_HOLDINGS_EXPOSURES_DATA = 'GET_HOLDINGS_EXPOSURES_DATA';
export const SET_HOLDINGS_EXPOSURES_DATA = 'SET_HOLDINGS_EXPOSURES_DATA';
export const HOLDINGS_DATA_ERROR = 'HOLDINGS_DATA_ERROR';
export const SELECT_ASSET = 'SELECT_ASSET';
export const DESELECT_ASSET = 'DESELECT_ASSET';
export const SET_ASSET_PERFORMANCE = 'SET_ASSET_PERFORMANCE';
export const CLEAR_HOLDINGS_STATE = 'CLEAR_HOLDINGS_STATE';
export const SET_AVAILABLE_BALANCE = 'SET_AVAILABLE_BALANCE';

export class GetHoldingsExposuresData implements Action {
    readonly type = GET_HOLDINGS_EXPOSURES_DATA;
    constructor(public payload: IHoldingsRequest) { }
}
export class GetHoldingsValuationData implements Action {
    readonly type = GET_HOLDINGS_VALUATION_DATA;
    constructor(public payload: IHoldingsRequest) { }
}
export class GetHoldingsAllocationsData implements Action {
    readonly type = GET_HOLDINGS_ALLOCATIONS_DATA;
    constructor(public payload: IHoldingsExposuresDataResult) { }
}
export class SetHoldingsValuationData implements Action {
    readonly type = SET_HOLDINGS_VALUATION_DATA;
    constructor(public payload: IHoldingsValuationsDataResult) { }
}
export class SetHoldingsExposuresData implements Action {
    readonly type = SET_HOLDINGS_EXPOSURES_DATA;
    constructor(public payload: IHoldingsExposuresDataResult) { }
}
export class SelectAsset implements Action {
    readonly type = SELECT_ASSET;
    constructor(public payload: IAssetDrilldownRequest) { }
}
export class DeselectAsset implements Action {
    readonly type = DESELECT_ASSET;
    constructor(public payload: number) { }
}
export class SetAssetPerformance implements Action {
    readonly type = SET_ASSET_PERFORMANCE;
    constructor(public payload: IAssetPerformance) { }
}
export class HoldingsDataError implements Action {
    readonly type = HOLDINGS_DATA_ERROR;
    constructor(public payload: string) { }
}
export class SetAvailableBalance implements Action {
    readonly type = SET_AVAILABLE_BALANCE;
    constructor(public payload: number) { }
}

export type HoldingsActions = GetHoldingsValuationData |
    SetHoldingsValuationData | GetHoldingsAllocationsData |
    SetHoldingsExposuresData | GetHoldingsExposuresData | SelectAsset | DeselectAsset | SetAssetPerformance |
    HoldingsDataError | SetAvailableBalance;
